import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { ArrowLeft, Shield } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(`${API}/auth/admin/login`, {
                email: email,
                password: password
            });

            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('userType', response.data.user_type);
            localStorage.setItem('userEmail', email);

            toast.success('Admin login successful!');
            navigate('/admin/dashboard');
        } catch (error) {
            toast.error('Invalid admin credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#fcf6e3' }}>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="w-full max-w-md px-6"
            >
                <Card>
                    <CardHeader>
                        <div className="text-center mb-4">
                            <h1 className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif', color: '#701a25' }}>
                                MVC VET TELECARE
                            </h1>
                            <p className="text-sm" style={{ color: '#d9a520' }}>Veterinarian Portal</p>
                        </div>
                        <CardTitle className="text-center">
                            <Shield className="w-12 h-12 mx-auto mb-4" style={{ color: '#701a25' }} />
                            Admin Login
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <form onSubmit={handleLogin} className="space-y-4">
                            <div>
                                <Label htmlFor="admin-email">Email Address</Label>
                                <Input
                                    id="admin-email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="admin@mvcvettelecare.com"
                                    required
                                />
                            </div>
                            <div>
                                <Label htmlFor="admin-password">Password</Label>
                                <Input
                                    id="admin-password"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="••••••••"
                                    required
                                />
                            </div>
                            <Button type="submit" className="btn-primary w-full" disabled={loading}>
                                {loading ? 'Logging in...' : 'Login as Admin'}
                            </Button>
                        </form>
                        <div className="mt-6 text-center">
                            <Button variant="link" onClick={() => navigate('/')}>
                                <ArrowLeft className="w-4 h-4 mr-1" /> Back to Home
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </motion.div>
        </div>
    );
};

export default AdminLogin;
